module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Regular.b3b225b8.woff";